(function() {
    'use strict';

a3_cabin_reports.factory('FoundPropertyFactory', FoundPropertyFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FoundPropertyFactory
    * @description 
    *   Manage Report's found property.
    * @ngInject
    */
function FoundPropertyFactory(GenericModalFactory) {

        /**
         * Initialiaze Found Property object 
         * @memberof FoundPropertyFactory
         */
		function FoundProperty() {
			this.Id = null;
			this.Category = null;
			this.DetailedDescription = null;
            this.SeatRow = null;
            this.Seat = null;
            this.Label = 'Found Property';
            this.Images = [];
            this.Comments = null;
            this.Signature = null;
            this.AgentName = null;
            this.Status = 'draft'; // 'draft' or 'completed'
		}

		var service = {
			createNew : createNew
		}
			
        /**
         * Create a new Found Property object 
         * @memberof FoundPropertyFactory
         * @returns {object} FoundProperty
         */
		function createNew() {
			return GenericModalFactory.createNew(FoundProperty)
		}

		return service;
	}

})();